import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

export {
    React,
    ReactDOM,
    PropTypes
}

export default {
    "react": React,
    "react-dom": ReactDOM,
    "prop-types": PropTypes
}


// WEBPACK FOOTER //
// ./packages/~react/index.js